import Constant from '@/common/constant/Constant';
import { useState, useEffect } from 'react';
import RichTextEditor from '@/component/formManagement/fieldUI/RichTextEditor';


export default function ReplyEmailBody({
    originTicket,
    fieldData,
    isCustomerMail = false,
    detailTicket,
    onclickReplyTicket,
    replyToEmailTicket,
    setIsEdited,
    register,
    setValue,
    triggerEnableBtnSaveTicket
}) {


    const [onChangeEdit, setOnChangeEdit] = useState(false);
    const [bodyHtml, setBodyHtml] = useState('');
    const [listFieldEdited, setListFieldEdited] = useState([]);

    const [errorlist, setErrorlist] = useState('');

    useEffect(() => {
        if (fieldData) {
            let body = '';
            try {
                body = JSON.parse(fieldData?.value)
            } catch (error) {
                body = fieldData?.value;
            }
            setBodyHtml(body)
        }
    }, [
        fieldData
    ]);

    if (fieldData?.structure) {
        fieldData.structure.required = true;
    }

    let props = {
        defaultValue: fieldData?.defaultValue ?? '', // default value
        name:fieldData.id,
        data: fieldData,
        setIsEdited: setIsEdited,
        onChangeEdit: onChangeEdit,
        setOnChangeEdit: setOnChangeEdit,
        errorlist: errorlist,
        setErrorlist: setErrorlist,
        setValue,
        detailTicket: detailTicket,
        viewFromProjectOfEscalateTicket: false,
        label:  fieldData?.name?.jp?.text,
        register: register,
        listFieldEdited: listFieldEdited,
        setListFieldEdited: setListFieldEdited,
        triggerEnableBtnSaveTicket,
    }

    return <RichTextEditor {...props} />;
    
}
